import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import SimpleBar from 'simplebar-react';
import logoSm from '../assets/images/logo-sm.png';
import logoDark from '../assets/images/logo-dark.png';
import logoLight from '../assets/images/logo-light.png';
import VerticalLayout from './VerticalLayouts/index';
import { Container } from 'reactstrap';

const Sidebar = ({ layoutType }) => {
  useEffect(() => {
    const verticalOverlay = document.querySelector('.vertical-overlay');
    if (verticalOverlay) {
      verticalOverlay.addEventListener('click', () => {
        document.body.classList.remove('vertical-sidebar-enable');
      });
    }
  }, []);

  const addEventListenerOnSmHoverMenu = () => {
    const sidebarSize = document.documentElement.getAttribute('data-sidebar-size');
    if (sidebarSize === 'sm-hover') {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover-active');
    } else if (sidebarSize === 'sm-hover-active') {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    } else {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    }
  };

  return (
    <div className="app-menu navbar-menu">
      <div className="navbar-brand-box">
        <Link to="/" className="logo logo-dark">
          <span className="logo-sm">
            <img src={logoSm} alt="" height="22" />
          </span>
          <span className="logo-lg">
            <img src={logoDark} alt="" height="17" />
          </span>
        </Link>
        <Link to="/" className="logo logo-light">
          <span className="logo-sm">
            <img src={logoSm} alt="" height="22" />
          </span>
          <span className="logo-lg">
            <img src={logoLight} alt="" height="17" />
          </span>
        </Link>
        <button
          onClick={addEventListenerOnSmHoverMenu}
          type="button"
          className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
          id="vertical-hover"
        >
          <i className="ri-record-circle-line"></i>
        </button>
      </div>
      <SimpleBar id="scrollbar" className="h-100">
        <Container fluid>
          <ul className="navbar-nav" id="navbar-nav">
            <VerticalLayout layoutType={layoutType} />
          </ul>
        </Container>
      </SimpleBar>
      <div className="sidebar-background"></div>
      <div className="vertical-overlay"></div>
    </div>
  );
};

export default Sidebar;